import { render, staticRenderFns } from "./IconFgt.vue?vue&type=template&id=a3b49018&"
import script from "./IconFgt.vue?vue&type=script&lang=js&"
export * from "./IconFgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports